import React from 'react';

import ManualBillEditContainer from '../../../../bills/components/create/ManualBillEditContainer';

export default function BillAddEditScreen() {
    return <ManualBillEditContainer />;
}
